module.exports = __webpack_public_path__ + "img/7be34d0.jpg";